import {
  createContext,
  useEffect,
  useState,
  useContext,
  useRef,
  Fragment,
  useCallback
} from "react";
import { useNavigate,useOutletContext } from 'react-router-dom';
import expandprompt from "../../assets/images/byod-images/expand.svg";
import freepik1 from "../../assets/images/byod-images/freepik1.svg";
import freepik2 from "../../assets/images/byod-images/freepik2.svg";
import {byodSendImg} from "../../../src/commonImage";
import dashboardnav from "../../assets/images/byod-images/dashboardnav.svg";
import {
  setByodDocOpenClose,
  setSurveyDocOpenClose
} from "../../store/actions/commonActions";
import{  saveUserDocumentThreadHistory,setLastDeletedThreadID} from "../../store/actions/userChatActions";
import { v4 as uuidv4 } from "uuid";
import _, { set } from "lodash";
import {
  MotifCheckbox,
  MotifSearch,
  MotifFormField,
  MotifPaginationSelect,
  MotifPaginationSelectItem,
  MotifButton,
  MotifBreadcrumb,
  MotifBreadcrumbItem,
  MotifInput,
  MotifTextArea,
  MotifTooltip,
  MotifRichTextEditor
} from "@ey-xd/motif-react";
import { useDispatch } from "react-redux";
import MotifToast from "@ey-xd/motif-react/components/toast";
import "./ExploreData.css";
import "./ProjectDashboard.css";
import ExloreRightPanal from "./ExploreDataRightPanal";
import ExplorePhase from "./ExplorePhase";
import { DashboardContext } from "../../context/dashboardContext";
import DocumentService from "../../services/document.service";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { explorerDataConstants } from "./constants.js";
import { setSideBarOpenClose,numberOfSelectedDocs } from "../../store/actions/commonActions";
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import { REACT_APP_POLLING_TIME_IN_SECOND } from "../../app.constant";
import SuggestionText from "../common/errorPages/ErrorSuggestion";
import AIDisclaimerText from "../sideBarComponent/AIDisclaimerText";
import EYPAILanding from '../../assets/images/EYPAILanding.png';
import Utils from "../../utils/Utils";
import { MotifIconButton } from '@ey-xd/motif-react/Button';
import ExpandPromptModal from "./ExpandPromptModal";
import LinkButton from '../LinkButton/LinkButton';
import { downloadImg } from '../../commonImage';
import  useExportToFile  from '../openAIChat/utils/useExportToFile';
import improvePrompt from "../../assets/images/byod-images/improve_prompt.svg";
import { ImprovePromptModal } from "./ImprovePromptModal";

const ExploretData = () => {
  const exploreQuestionRef = useRef(null);
  const location = useLocation();
  // const defaultAskQuestion = location.state?.promptText ?? "";
  const documentservice = new DocumentService();
  const [askQuestionLength, setAskQuestionLength] = useState(0);
  const [askQuestion, setAskQuestion] = useState('');
  const [questions, setQuestions] = useState([]);
  const [confPublic, SetConfPublic] = useState("C");
  const [publicClick, setPublicClick] = useState(false);
  const [confClick, setconfClick] = useState(true);
  const [isSubmitpromt, setIsSubmitPrompt] = useState(false);
  const [showPromptHistory, setShowPromptHistory] = useState(false);
  const[showDocuments, setShowDocuments] = useState(false);
  const showDocumentsRef = useRef(false);
  const projectName = sessionStorage.getItem("DashboardProjectName");
  const isRightSideBarOpen = useSelector((state) => state.common.isRightSideBarOpen);
  const isSideBarOpen = useSelector((state) => state.common.isSideBarOpen);
  const isByodOpen = useSelector((state) => state.common.isByodOpen);
  const [isByodSourceDocsOpen, setIsByodSourceDocsOpen] = useState(false);
  const [isInterSideBarOpen, setIsInterSideBarOpen] = useState(false);
  const documentThreads = useSelector((state) => state.userChat.documentThreadHistory);
  const lastDeletedThreadID = useSelector((state) => state?.userChat?.lastDeletedThreadID);
  const selectedDocumentThread = useSelector(
    (state) => state.userChat.selectedDocumentThread
  );
  const userEmailId = useSelector((state) => state.common.userEmail);
  const dispatch = useDispatch();
  const { exportToBYODWord } = useExportToFile();
const {
  isDocumentUploadProcessInitiated,
  setIsDocumentUploadProcessInitiated,
  showDocumentUploadMessage,
  setShowDocumentUploadMessage,
  viewPrompt,
  isNewPromptCoversation,
  setIsNewPromptCoversation,
} = useContext(DashboardContext);
const redirectTo = useNavigate();
const [showUploadComplete, setShowUploadComplete] = useState(false);
const [showUploadInPorgress, setShowUploadInPorgress] = useState(false);
const [selectedSourceDocs, setSelectedSourceDocs] = useState("");
const[checkedSourceDocs, setCheckedSourceDocs] = useState([]);
const [isUploadInProgressDisplayed, setIsUploadInProgressDisplayed] = useState(false);
const[isDocsButtonDisabled, setIsDocsButtonDisabled] = useState(false);
const [isResonseLoading, setIsResonseLoading] = useState(false);
const highlightExploreDataNavigationOption = useOutletContext();
const refToScroll = useRef(null);
const [srcDocDrpDwnItems, setSrcDocDrpDwnItems] = useState(
  explorerDataConstants.Types
);

  const promptRef = useRef(null);
  const [isSrcDocActive, setIsSrcDocActive] = useState(false);
  const utils = new Utils();
  const [expandPromptModal, setExpandPromptModal] = useState(false);
  const [askQuestionDisable, setaskQuestionDisable] = useState(false);
  const [isSendBtnDisable, setIsSendBtnDisable] = useState(false);
const isLoading = useSelector((state) => state.userChat.isLoading);

const numberOfDocs = useSelector((state) => state.common.numberOfSelectedDocs);
const uploadChatData = useSelector((state) => state.userChat.uploadChatData);
const userData = useSelector((state) => state.userProfile?.userData);
const [isImprovePromptDisabled, setIsImprovePromptDisabled] = useState(true);
const [matchedFiles, setMatchedFiles] = useState(null);
const [showPopupImprovePrompt, setShowPopupImprovePrompt] = useState(false);
const [richTextEditorInstance, setRichTextEditorInstance] = useState(null);
const [resultedDocs, setResultItems] = useState([])
const [conversation_ID, setConversation_ID] = useState('');

  useEffect(() => {
   setConversation_ID(uuidv4());
  }, []);

const TEXT_HEIGHT = askQuestion.length > 150 ? 60 : 44;
  useEffect(()=> {
  if(!selectedDocumentThread?.threadId){
    redirectTo('/uploadPage')
    }else{
      setIsByodSourceDocsOpen(true);
      setShowDocuments(true);
      dispatch(setSideBarOpenClose(false));
    }
    dispatch(setSurveyDocOpenClose(false));
    setQuestions([]);
    setAskQuestion('');
    dispatch(setSideBarOpenClose(true));
    setIsDocsButtonDisabled(false);
    setCheckedSourceDocs([]);
    setSrcDocDrpDwnItems(explorerDataConstants.Types);
  },[selectedDocumentThread])

  useEffect(()=> {
    return () => {
      if(location.state?.promptText !== undefined) {
        location.state.promptText = "";
      }
    }
  },[])

useEffect(() => {
  dispatch(setByodDocOpenClose(showDocuments))
  setIsByodSourceDocsOpen(showDocuments);
  showDocuments && setIsInterSideBarOpen(false);
  showDocuments?dispatch(setSideBarOpenClose(false)):"";
},[showDocuments,isSideBarOpen,isByodOpen,isRightSideBarOpen]);

  useEffect(()=>{
    if(location.state?.promptText !== "" && location.state?.promptText!== undefined) {
      setAskQuestion(location.state?.promptText);
      document.getElementById('question')?.focus();
      highlightExploreDataNavigationOption();
    }
    if(isSubmitpromt===true){
      setAskQuestion('');
    }
  }, [questions]);

  useEffect(() => {
    if (viewPrompt && viewPrompt?.requestContent) {
      let quests = [];
      quests.push(viewPrompt.requestContent);
      setQuestions(quests);
      //setQuestions([...questions, viewPrompt.requestContent]);
      setAskQuestion("");
      setShowPromptHistory(true);
      if (viewPrompt?.isPublicConfidential == "C") {
        SetConfPublic("C");
        setPublicClick(false);
        setconfClick(true);
      } else {
        SetConfPublic("P");
        setPublicClick(true);
        setconfClick(false);
      }
    }
  }, [viewPrompt]);

  useEffect(() => {
    if (isNewPromptCoversation) {
      setQuestions([]);
      setIsNewPromptCoversation(false);
    }
  }, [isNewPromptCoversation]);

  useEffect(() => {
    if (showDocumentUploadMessage && isUploadInProgressDisplayed) {
      setIsUploadInProgressDisplayed(false);
      setShowUploadInPorgress(true);
    }
  }, [showDocumentUploadMessage]);

  useEffect(() => {
    if (isDocumentUploadProcessInitiated) {
      let interval = setInterval(async () => {
        const uploadDocuments = await documentservice.getDocuments(
          selectedDocumentThread?.threadId,selectedDocumentThread?.title,userEmailId
        );
        if (uploadDocuments.length > 0) {
          const notCompletedDocs = _.filter(uploadDocuments, function (item) {
            return item.status !== "Complete";
          });
          if (notCompletedDocs.length > 0) {
            if (!showDocumentUploadMessage) {
              setShowDocumentUploadMessage(true);
              setIsUploadInProgressDisplayed(true);
            }
          } else {
            setShowUploadComplete(true);
            setTimeout(() => {
              setShowUploadComplete(false);
            },3000)
            setIsDocumentUploadProcessInitiated(false);
            clearInterval(interval);
          }
        }
      },500 * parseInt(REACT_APP_POLLING_TIME_IN_SECOND));
      return () => {
        clearInterval(interval);
      };
    }
  }, [isDocumentUploadProcessInitiated]);

  useEffect(() => {
    if (lastDeletedThreadID != 0) {
      const updated = documentThreads.filter((item: any) => item.threadId !== lastDeletedThreadID);
      dispatch(saveUserDocumentThreadHistory(updated));
      dispatch(setLastDeletedThreadID(0));
    }
  }, [lastDeletedThreadID,documentThreads]);

  const OnChangeQuestion = (event) => {
    const text = event.replace(/<[^>]*>/g, '').trim();
    setAskQuestionLength(text.length);
    setAskQuestion(event);
  };

  const handleFocusQuestion = (event) => {
    setShowDocuments(true);
    showDocumentsRef.current = true;
    setIsByodSourceDocsOpen(showDocuments);
    dispatch(setByodDocOpenClose(showDocuments))
    dispatch(setSideBarOpenClose(false))
    setIsInterSideBarOpen(false);
  }
  const isElementsDisabled = (val) => {
    setIsDocsButtonDisabled(false);
    setTimeout(() => {
      scrollToBottom();
    }, 300);
  }
  const selectedDropDowndocs = (item) => {
    setSrcDocDrpDwnItems(item);
  }

// exploreQuestion && exploreQuestion.addEventListener("keydown", (event) => {
//   if (event.isComposing || event.keyCode === 13) {
//     event.preventDefault();
//     event.target.closest(".explore-data-container-prompt-question-container").querySelector(".explore-data-container-sendimage").click();
//     //onSendPrompt();
//   }
// });


// const handleKeyDown = useCallback((event) => {
//   if (event.isComposing || event.keyCode === 13 || event.key === 'Enter') {
//     event.preventDefault();
//     const sendButton = event.target.closest(".explore-data-container-prompt-question-container").querySelector(".explore-data-container-sendimage");
//     if (sendButton) {
//       sendButton.click();
//     }
//   }
// }, []);

// useEffect(() => {
//   const exploreQuestion = exploreQuestionRef.current;
//   if (exploreQuestion) {
//     exploreQuestion.addEventListener("keydown", handleKeyDown);
//   }

//   return () => {
//     if (exploreQuestion) {
//       exploreQuestion.removeEventListener("keydown", handleKeyDown);
//     }
//   };
// }, [handleKeyDown]);

  const sendButtonValidations = () => {
    if (askQuestionDisable) {
      setIsSendBtnDisable(true);
    }
    else {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = askQuestion;
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        if (textContent.trim() === "") {
          setIsSendBtnDisable(true);
        } else {
        setIsSendBtnDisable(false);
      }
  }
}


  useEffect(() => {
    sendButtonValidations();
  }, [askQuestionDisable, askQuestion])

  const handleQuestionFocus = (isSrcDocActive) => {
    setIsSrcDocActive(isSrcDocActive);
  }

  const onSendPrompt = () => {
    setIsResonseLoading(true);
    setIsDocsButtonDisabled(true);
    setaskQuestionDisable(true);
    if (askQuestion !== "") {
      if (questions.length === 0) {
        if (sessionStorage.getItem("PromptConversationId")) {
          sessionStorage.removeItem("PromptConversationId");
        }
        sessionStorage.setItem("PromptConversationId", conversation_ID);
      }
      if (showPromptHistory) {
        setShowPromptHistory(false);
      }
      setQuestions([...questions, askQuestion]);
      setAskQuestion("");
      setIsSubmitPrompt(true);
    }
    // setTimeout(() => {
    //   document.querySelectorAll("#question")[0].focus();
    // },200);
  };
  
  const AddPromptToQuestionBar = (EditPrompt = String) => {
    setAskQuestion(EditPrompt);
    setShowPopupImprovePrompt(false);

  };

  function selctedSourceDocs(selectdocs) {
    setCheckedSourceDocs(selectdocs);
    let resultitems = selectdocs?.filter((item) => {
      return item?.selected;
    });
    dispatch(numberOfSelectedDocs(resultitems?.length));
    let docnames = "";
    let docarray = [];
    if (resultitems?.length > 0) {
      resultitems.map((item) => {
        docarray.push(item.documentName);
      });
      docnames += docarray.toString();
    }
    setResultItems(resultitems);
    setSelectedSourceDocs(docnames);
    setaskQuestionDisable(docnames === 0);

  }
  const breadcrumbs = [{ label: 'Home' }, { label: 'Upload Document and Query', current: true }];

  const scrollToBottom = () => {
    refToScroll?.current?.scroll({
      left: 0,
      top: refToScroll.current.scrollHeight,
      behavior: 'smooth'
    });
  };

  const isResponseLoadingFunc = () => {
    setIsResonseLoading(false);
  };

    const viewExpandPrompt = () => {
    setExpandPromptModal(true);
  };

    const hasAlphaNumeric = (str) => {
      const text = str.replace(/<[^>]*>/g, '').trim();
      return /[a-zA-Z0-9]/.test(text) && text.length > 0;
    };

   const handlePromptSubmit = (event) => {

      // On Enter press (with no shift key) submit the prompt
      if (event.code === 'Enter' && !event.shiftKey) {
          if(!hasAlphaNumeric(event.target.innerHTML)) {
            event.preventDefault();
            return;
          }
          if (selectedSourceDocs != '') {
            onSendPrompt();
            setAskQuestion("")
          }
          else {
            setAskQuestion(askQuestion.substring(0, askQuestion.length - 1));
            event.preventDefault();
          }
        }
        else if (publicClick) {
            onSendPrompt();
            setAskQuestion("")
        }
  };

  const stripHtml = (html) => html?.replace(/<[^>]*>/g, '') ?? '';

  const handleDocDownload = () => {
    const chatData = uploadChatData && uploadChatData.length > 0 && uploadChatData.map((item) => {
      return {
        user: stripHtml(item.req),
        summary: item.res?.responseContent,
      };
    });
    exportToBYODWord(chatData,userData?.profileImage);
  }

  useEffect(() => {
    const promptEditor = promptRef.current;
    const numberedBtn = promptEditor.querySelector(`button[value="ordered"]`);
    const bulletBtn = promptEditor.querySelector(`button[value="bullet"]`);
    if ( numberOfDocs < 1 ) {
      numberedBtn.disabled = true;
      bulletBtn.disabled = true;
    } else {
      numberedBtn.disabled = false;
      bulletBtn.disabled = false;
    }
    utils.addCustomTooltip(numberedBtn, 'Numbered list', 'NumberedList', 'top');
    utils.addCustomTooltip(bulletBtn, 'Bulleted list', 'BulletedList', 'top');

    return () => {
      let tooltipNumberedList = document.getElementById('tooltipNumberedList');
      if (tooltipNumberedList) {
        document.body.removeChild(tooltipNumberedList);
      }
      let tooltipBulletedList = document.getElementById('tooltipBulletedList');
      if (tooltipBulletedList) {
        document.body.removeChild(tooltipBulletedList);
      }
    };
  }, [selectedSourceDocs, numberOfDocs]);


    const motifReactEditorModules = {
    toolbar: [[{
      list: 'ordered'
    }, {
      list: 'bullet'
    },
    ]],
    clipboard: {
      matchVisual: false
    }
  };

    useEffect(() => {
      setIsResonseLoading(false);
  },[isLoading]);

   const openImprovePromptModal = () => {
    setShowPopupImprovePrompt(true);
  };

   const closePopups = () => {
    setShowPopupImprovePrompt(false);
  };

  
  useEffect(() => {
 if (askQuestion === "<p><br></p>" || askQuestion === "") {
      setIsImprovePromptDisabled(true);
    }  else {
      setIsImprovePromptDisabled(false);
      if (matchedFiles?.length > 0 ) {
        setIsImprovePromptDisabled(true);
      }
    }
  
  //  eslint-disable-next-line
  }, [askQuestion, matchedFiles, isImprovePromptDisabled ]);

  //   useEffect(() => {
  //   const text = richTextEditorInstance?.getText()?.trim();
  //   if (text?.length > 0) {
  //     const tempQuestion = text.split(',').map(_.trim)
  //     const documentNames = filteredFileList
  //       .filter((item) => item.documentName)
  //       .map((item) => item.documentName);
  //     // check for the documents that are on the list selected
  //     const matchingItems = tempQuestion.filter(item => documentNames.includes(item));
  //     setMatchedFiles(matchingItems);
  //   }
  // }, [askQuestion, isImprovePromptDisabled])

  return (
    <div className={`${isRightSideBarOpen? "exploredata-open":"exploredata-close"} exploreDataContainer ${isSideBarOpen||isInterSideBarOpen?"datasourcebar-open":"datasourcebar-close"} ${isByodOpen||isByodSourceDocsOpen?"sourcedocs-open":"sourcedocs-close"}`}>
      {/* <ExploreContextProvider> */}
      <div className={isRightSideBarOpen ? 'breadcrumbOpen' : 'breadcrumb'}>
          <Breadcrumb items={breadcrumbs} />
        </div>
      <div className="explore-data-text">Explore your data</div>
     <div className="hideview-docs manage-docs">
     <MotifButton
                 disabled={isDocsButtonDisabled}
                className={
                    "confpublic ActivePublic manage-docs-button"
                }
                onClick={() => {
                  dispatch(setByodDocOpenClose(false));
                  setIsByodSourceDocsOpen(false);
                  redirectTo('/uploadPage');
                  
                  //showDocuments?setSideBarOpenClose(true):setSideBarOpenClose(false);
                }}
              >Manage documents</MotifButton>
      <MotifButton
                disabled={isDocsButtonDisabled}
                className={
                    "confpublic ActivePublic view-hide-docs"
                }
                onClick={() => {
                  setShowDocuments(!showDocuments);
                  showDocumentsRef.current = !showDocuments;
                  showDocumentsRef.current && setIsInterSideBarOpen(false);
                  showDocumentsRef.current?dispatch(setSideBarOpenClose(false)):"";
                  showDocumentsRef.current?setIsByodSourceDocsOpen(true):setIsByodSourceDocsOpen(false);
                }}
              >{showDocuments?'Hide source documents':'View source documents'}</MotifButton>
      </div>
       
      {(showDocuments && <div className="explore-data-right-panel">
        <ExloreRightPanal
          publicOrConfidential={confPublic}
          selectdocs={selctedSourceDocs}
          checkedSourceDocs={checkedSourceDocs}
          selectedDropDowndocs={selectedDropDowndocs}
          checkedDropdownDocs={srcDocDrpDwnItems}
        />
      </div>)}

      <div className={`explore-data-container ${ !showDocuments?"hidedocuments":"visibledocuments"}`}  id="id-scroll-explore-data-container">
        <div ref={refToScroll} className="explore-data-container-child">
          {questions.length === 0 && (
            <div className="explore-data-container-without-quest">
              <div className="explore-data-container-image-container">
                <img src={EYPAILanding} alt="no document image"></img>
                <div className="explore-data-container-image-container-child">
                  <div className="explore-data-container-image-container-text">
                  </div>
                  <div className="explore-data-container-image-container-tagline">
                  </div>
                </div>
              </div>
            </div>
          )}

          {questions.length > 0 &&
            questions.map((question,index) => {
              return (
                <div key={index} className="explore-data-container-with-quest">
                  <ExplorePhase
                    isResponseLoadingFunc={isResponseLoadingFunc}
                    question={question}
                    publicConf={confPublic}
                    addprompt={AddPromptToQuestionBar}
                    isPromptSubmit={isSubmitpromt}
                    showPromotHistory={showPromptHistory}
                    selectedDocNames={selectedSourceDocs}
                    elementsDisabled={isElementsDisabled}
                  />
                </div>
              );
            })}
            <div className="explore-data-container-promptarea-container">
                    <div className="explore-data-container-prompt-question-container">
                      <MotifFormField
                        className={isResonseLoading ? "width-margin-cursor-disabled" :"width-margin"}
                      >
                        <div ref={promptRef}>
                          <MotifRichTextEditor
                            id="question"
                            placeholder="Ask a question"
                            value={askQuestion}
                            modules={motifReactEditorModules}
                            onKeyDown={handlePromptSubmit}
                            onChange={(content, delta, source, editor) => {
                              setRichTextEditorInstance(editor);
                              // const range = editor.getSelection(true);
                              // const bounds = editor.getBounds(range.index);

                              // setModalPosition({
                              //   top: bounds.top + 30,
                              //   left: bounds.left,
                              //   bottom: bounds.top + 5
                              // });
                              if (typeof content === "string") {
                                  const cleanValue = content.replace(/<span[^>]*style="[^"]*color:[^;"]*;?[^"]*"[^>]*>(.*?)<\/span>/gi, '$1')
                                                      .replace(/<font[^>]*color="[^"]*"[^>]*>(.*?)<\/font>/gi, '$1');
                                  OnChangeQuestion(cleanValue);
                                } else {
                                  OnChangeQuestion(content);
                                }
                              // handlePromptChange(content);
                            }}
                            onKeyPress={(e) => { if (e.key === 'Enter') { onSendPrompt() } }}
                            onFocus={handleFocusQuestion}
                            maxLength={1000}
                            disabled={isResonseLoading || numberOfDocs < 1 ? true : false}
                          />
                        </div>

                           <div className="improvePromptContainer">
                        <MotifTooltip
                          allowClick={false}
                          placement="top"
                          hideCloseButton={true}
                          contentClassName="improve-prompt-Tooltip"
                          trigger={
                            <div className="buttonContent">
                              <MotifIconButton
                                data-testid="improvePrompt"
                                className="improvePromptButton"
                                disabled={isImprovePromptDisabled}
                                onClick={() => openImprovePromptModal()}
                              >
                                <img
                                  src={improvePrompt}
                                  className="improvePromptIcon"
                                  id="improvePrompt"
                                  alt="improve prompt"
                                />
                                <span className={isImprovePromptDisabled ? "buttonLableDisable":"buttonLabel"}>
                                  Improve Prompt
                                </span>
                              </MotifIconButton>
                            </div>
                          }
                        >

                           {(matchedFiles?.length > 0) ?

                            (<>
                             Remove the document references
                              <br />
                               in the prompt to enable
                            </>)
                            :
                            (isImprovePromptDisabled) ? 
                             (( (askQuestion === "<p><br></p>" || askQuestion === "") ? <>
                                Enter a prompt in the
                                <br />
                                chat bar to continue                             
                              </> :
                              ((askQuestion === "<p><br></p>" || askQuestion === "") ? 
                              <>
                                Enter a prompt in the
                                <br />
                                chat bar to continue
                              </> : <>
                               Select a project scope 
                               <br /> to continue
                              </> )
                              )
                            ) : <>
                                Improve your prompt
                                <br />
                                with the help of AI
                              </>
                            }
                        </MotifTooltip>
                      </div>

                        <MotifIconButton
                          className="btnExpandPrompt"
                          onClick={() => viewExpandPrompt()}
                          disabled={numberOfDocs < 1}
                        >
                          <MotifTooltip
                            placement="top"
                            contentClassName="tooltipWithoutCloseCenterText tooltipExpandBtn"
                            hideCloseButton={true}
                              trigger={<img className = "expand-button-ce" src={expandprompt} alt="" />}
                          >
                            Expand
                          </MotifTooltip>
                        </MotifIconButton>

                         <MotifButton
                            className={`btnSendPrompt ${(askQuestionLength > 0 && numberOfDocs > 0) ? "active-send-button" : ""} ${isResonseLoading && "cursor-disabled"} `}
                            onClick={onSendPrompt}
                            disabled={isResonseLoading || !(numberOfDocs > 0 && askQuestionLength > 0) ? true : false}   
                          >
                          <MotifTooltip
                            hide={numberOfDocs > 0}
                            placement="top"
                            hideCloseButton={true}
                            contentClassName="tooltipWithoutCloseCenterText sendBtnTooltip"
                             trigger={
                              <img className="tooltipImage"src={byodSendImg} alt="" />
                            }
                            >
                            <span className="sendTooltipContent1" >{"No files selected"}</span>
                            <br /><span className="sendTooltipContent2" >{"Please select a file from the 'Source documents' tab"}</span>
                          </MotifTooltip>

                        </MotifButton>
                      </MotifFormField>
                      </div>
                      <LinkButton onClick={() => handleDocDownload()}
                        disabled={isResonseLoading || !( questions.length > 0) ? true : false}
                      >
                        <img src={downloadImg} /> &nbsp;
                        <span className='download-button'>Download Chat</span>
                      </LinkButton>
                     <div className="explore-data-container-response-note">
                        <AIDisclaimerText hideHeadingText = {true}/>
                    </div>
                  </div>
                  </div>
      </div>
      {showUploadInPorgress && (
        <MotifToast
        className="documents-ready"
          variant="info"
          actionName=""
          position="bottom"
          onClose={() => {
            setShowUploadInPorgress(false);
          }}
        >
          <div>
            Upload complete. Getting your documents ready for prompt. You can
            now exit Competitive Edge.
          </div>
        </MotifToast>
      )}
      {showUploadComplete && (
        <MotifToast
          variant="success"
          actionName=""
          position="bottom"
          onClose={() => {
            setShowUploadComplete(false);
          }}
        >
          <div>
            Upload complete. Getting your documents ready for prompt. You can
            now exit Competitive Edge.
          </div>
        </MotifToast>
      )}
      {/* </ExploreContextProvider> */}
      {expandPromptModal && (
          <div>
            <ExpandPromptModal
              expandPromptModal={expandPromptModal}
              setExpandPromptModal={setExpandPromptModal}
              questionBar={askQuestion}
              setQuestionBar={setAskQuestion}
            />
          </div>
        )}

         {showPopupImprovePrompt && (
          <ImprovePromptModal
            OpenModal={openImprovePromptModal}
            onClose={closePopups}
            requestData={{
              questionBar: askQuestion,
              scopeId: 'All',
              confPublic: confPublic,
              conv_UUID: conversation_ID,
              project_UUID: selectedDocumentThread?.threadId,
              projectType: localStorage.getItem("ProjectType"),
              fileList: resultedDocs && resultedDocs?.length > 0 ? resultedDocs?.filter(x => x.selected).map(x => x.documentName).join(",") : "",
              emailId: userEmailId,
              prompt_UUID: viewPrompt && viewPrompt.length > 0 ? viewPrompt[0].promptId : null,
            }}
            onUsePrompt={OnChangeQuestion}
          />
        )}
    </div>
  );
};

export default ExploretData;